import Cookies from 'universal-cookie'
import { taxonomiesLabels } from '@revbox/localization'
import { getPathKey } from '../../../contexts/CookiesContext'
import { cookiesKeyNames } from '@revbox/common-fe'

export default function Default_Taxonomy() {
    const cookies = new Cookies()

    const language = cookies.get(getPathKey())?.[cookiesKeyNames.language]?.value || 'EN'
    return taxonomiesLabels[language]
}
